import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Consumption = {
  id: string;
  name: string;
  score: number;
};

interface ConsumptionState {
  consumptions: Consumption[];
}

const initialState: ConsumptionState = {
  consumptions: [],
};

const consumptionSlice = createSlice({
  name: 'consumptions',
  initialState,
  reducers: {
    updateConsumption(state, action: PayloadAction<Consumption>) {
      if (state.consumptions.find(c => c.id === action.payload.id)) {
        state.consumptions[state.consumptions.findIndex(c => c.id === action.payload.id)].score = action.payload.score;
      } else {
        state.consumptions.push(action.payload);
      }
    },
    clearConsumptions(state) {
      state.consumptions = [];
    },
  },
});

export const consumptionActions = consumptionSlice.actions;
export default consumptionSlice.reducer;
